module.exports = __webpack_public_path__ + "static/media/dodgem(25).967138bd.PNG";